import { useTableStore } from '@/store/table/table'
import FilterCard from './FilterCard'
import OptionsFilter from './OptionsFilter'
import type { FilterWidgetProps } from './filterKinds'

/** The checkbox list of a column inside the shared card. Picking applies at once. */
const ListFilter = ({ field, spec }: FilterWidgetProps) => {
  const { apiFilters, updateFieldFilter } = useTableStore()
  const isActive = apiFilters.some(f => f.name === field && f.value.length > 0)

  return (
    <FilterCard
      title="בחירת ערכים"
      isActive={isActive}
      onClear={() => updateFieldFilter(field, [])}
    >
      <OptionsFilter
        bare
        field={field}
        options={spec.options?.source === 'static' ? spec.options.options : undefined}
        rowsOnly={spec.options?.source === 'rows'}
      />
    </FilterCard>
  )
}

export default ListFilter
